import type { MisconceptionSummary } from "@/lib/api";

/** Public URL of a misconception's own page. */
export const misconceptionPath = (m: Pick<MisconceptionSummary, "slug">) => `/clarifier/${m.slug}`;
